<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" role="doc-part">
<h1 class="h1part"><span aria-label="page 13" epub:type="pagebreak" id="page_13" role="doc-pagebreak">PART 1 <span class="heading_break">The Somatic Therapy Landscape</span></span></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?4dc79268